module.exports = __webpack_public_path__ + "static/img/data-use.8d1cf933.png";